import axios from 'axios';
import { BaseAPI } from './BaseAPI';

export class FileAPI extends BaseAPI {
  //上傳文件
  async uploadFile(body) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/upload`,
      body
    );
    return data;
  }

  //刪除文件
  async deleteDocument(ids) {
    const { data } = await axios.delete(
      `${this._getBasePathPublic()}/delete?ids=${ids}`
    );
    return data;
  }

  //刪除全部文件
  async deleteDocumentAll(applicationNo, typeIndex) {
    const { data } = await axios.delete(
      `${this._getBasePathPublic()}/deleteAll?applicationNo=${applicationNo}&typeIndex=${typeIndex}`
    );
    return data;
  }

  //刪除全部文件
  async getDocumentType(applicationType, companyType) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/type/${applicationType}/${companyType}`
    );
    return data;
  }

  //根据文件ID获取文件内容
  async getDocumentById(id) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/content/${id}`
    );
    return data;
  }

  //邮寄上传
  async mailingUpload(value) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/mailingUpload`,
      value
    );
    return data;
  }
}
export default new FileAPI({
  prefix: '',
  path: '/public/document',
});
